import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-5" }
const _hoisted_2 = { class: "\n          d-flex\n          flex-wrap-reverse\n          align-items-end\n          justify-content-between\n          text-nowrap\n        " }
const _hoisted_3 = { class: "flex-column me-4" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = { class: "card mb-4" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createVNode("h5", { class: "mb-0" }, "Behandlingsdetaljer")
], -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = /*#__PURE__*/_createVNode("strong", null, "Status:", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("strong", null, "Type:", -1)
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = /*#__PURE__*/_createVNode("strong", null, "Start:", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("strong", null, "Afsluttet:", -1)
const _hoisted_15 = { class: "card mb-4" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createVNode("h5", { class: "mb-0" }, "Sammendrag")
], -1)
const _hoisted_17 = { class: "card-body" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = { class: "text-primary" }
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "mb-0" }, "Tildelte roller", -1)
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = { class: "text-primary" }
const _hoisted_26 = /*#__PURE__*/_createVNode("p", { class: "mb-0" }, "Profiler påvirket", -1)
const _hoisted_27 = { class: "col-md-4" }
const _hoisted_28 = { class: "text-center" }
const _hoisted_29 = { class: "text-danger" }
const _hoisted_30 = /*#__PURE__*/_createVNode("p", { class: "mb-0" }, "Fejlede tildelinger", -1)
const _hoisted_31 = {
  key: 0,
  class: "card mb-4"
}
const _hoisted_32 = { class: "card-header" }
const _hoisted_33 = { class: "mb-0 text-danger" }
const _hoisted_34 = { class: "card-body" }
const _hoisted_35 = {
  key: 1,
  class: "card mb-4"
}
const _hoisted_36 = { class: "\n              card-header\n              d-flex\n              justify-content-between\n              align-items-center\n              mb-3\n            " }
const _hoisted_37 = { class: "mb-0" }
const _hoisted_38 = {
  class: "text-break",
  style: {"word-wrap":"break-word","max-width":"300px","display":"inline-block"}
}
const _hoisted_39 = {
  key: 2,
  class: "card"
}
const _hoisted_40 = { class: "card-body text-center py-5" }
const _hoisted_41 = /*#__PURE__*/_createVNode("p", { class: "mb-0" }, "Ingen rolle tildelinger blev behandlet", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pretty_bar = _resolveComponent("pretty-bar")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_VDButton = _resolveComponent("VDButton")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_NewSidebar = _resolveComponent("NewSidebar")!

  return (_openBlock(), _createBlock(_component_NewSidebar, {
    ref: "sidebarRef",
    class: "d-flex flex-column bg-white slide-bar-body-full-width",
    onOnHiding: _ctx.handleHideSidebar
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_pretty_bar),
            _createVNode("h2", null, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', _ctx.result.IsSimulation ? 'eye' : 'check'],
                class: "me-2"
              }, null, 8, ["icon"]),
              _createTextVNode(" " + _toDisplayString(_ctx.result.IsSimulation ? "Simulation" : "Udførelse"), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("p", null, [
                    _hoisted_10,
                    _createVNode("span", {
                      class: `badge ${
                      _ctx.result.Success ? 'bg-success' : 'bg-danger'
                    }`
                    }, _toDisplayString(_ctx.result.Success ? "Succesfuld" : "Fejl"), 3)
                  ]),
                  _createVNode("p", null, [
                    _hoisted_11,
                    _createTextVNode(" " + _toDisplayString(_ctx.result.IsSimulation ? "Simulation" : "Udførelse"), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("p", null, [
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(_ctx.displayDanishTimestamp(_ctx.result.ProcessedAt)), 1)
                  ]),
                  _createVNode("p", null, [
                    _hoisted_14,
                    _createTextVNode(" " + _toDisplayString(_ctx.displayDanishTimestamp(_ctx.result.FinishedAt)), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, [
                  _createVNode("div", _hoisted_20, [
                    _createVNode("h3", _hoisted_21, _toDisplayString(_ctx.result.TotalAssignments), 1),
                    _hoisted_22
                  ])
                ]),
                _createVNode("div", _hoisted_23, [
                  _createVNode("div", _hoisted_24, [
                    _createVNode("h3", _hoisted_25, _toDisplayString(_ctx.result.TotalUsersAssignment), 1),
                    _hoisted_26
                  ])
                ]),
                _createVNode("div", _hoisted_27, [
                  _createVNode("div", _hoisted_28, [
                    _createVNode("h3", _hoisted_29, _toDisplayString(_ctx.result.AssignedRoles?.filter((role) => !role.isSuccess)
                        .length || 0), 1),
                    _hoisted_30
                  ])
                ])
              ])
            ])
          ]),
          (_ctx.result.Errors && _ctx.result.Errors.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_31, [
                _createVNode("div", _hoisted_32, [
                  _createVNode("h5", _hoisted_33, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fas', 'exclamation-triangle'],
                      class: "me-2"
                    }),
                    _createTextVNode(" Fejl (" + _toDisplayString(_ctx.result.Errors.length) + ") ", 1)
                  ])
                ]),
                _createVNode("div", _hoisted_34, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.result.Errors, (error, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: "alert alert-danger"
                    }, _toDisplayString(error), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.result.AssignedRoles && _ctx.result.AssignedRoles.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_35, [
                _createVNode("div", _hoisted_36, [
                  _createVNode("h5", _hoisted_37, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fas', 'users'],
                      class: "me-2 text-success"
                    }),
                    _createTextVNode(" Resultat af rolletildelinger (" + _toDisplayString(_ctx.result.AssignedRoles.length) + ") ", 1)
                  ]),
                  _createVNode(_component_VDButton, {
                    isLoading: _ctx.exportReportToExcelLoading,
                    class: "primary",
                    onClick: _ctx.exportReportToExcel,
                    title: "Eksporter til Excel"
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.exportReportToExcelLoading)
                        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                            key: 0,
                            icon: ['fas', 'file-excel'],
                            size: "lg",
                            class: "me-2 ms-2"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["isLoading", "onClick"])
                ]),
                _createVNode(_component_DataTable, {
                  value: _ctx.result.AssignedRoles,
                  responsiveLayout: "scroll",
                  paginator: true,
                  rows: 30,
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "isSuccess",
                      header: "Fejlårsag",
                      style: {"padding":"unset","padding-left":"1rem"}
                    }, {
                      body: _withCtx(({ data }) => [
                        _createVNode("span", null, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: ['fas', data.isSuccess ? 'check' : 'minus'],
                            class: data.isSuccess ? 'text-success' : 'text-danger'
                          }, null, 8, ["icon", "class"])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "userName",
                      header: "User name",
                      style: {"padding-left":"1rem"}
                    }, {
                      body: _withCtx(({ data }) => [
                        _createVNode("span", null, _toDisplayString(data.userName || "-"), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "email",
                      header: "E-mail",
                      style: {"padding-left":"1rem"}
                    }, {
                      body: _withCtx(({ data }) => [
                        _createVNode("span", null, _toDisplayString(data.email), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "roleName",
                      header: "Rolle"
                    }, {
                      body: _withCtx(({ data }) => [
                        _createVNode("span", null, _toDisplayString(data.roleName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "organizationName",
                      header: "Organisation Navn"
                    }, {
                      body: _withCtx(({ data }) => [
                        _createVNode("span", null, _toDisplayString(_ctx.isNullEmptyOrUndefined(data.organizationName)
                      ? "-"
                      : data.organizationName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "failureReason",
                      header: "Fejlårsag"
                    }, {
                      body: _withCtx(({ data }) => [
                        _createVNode("span", _hoisted_38, _toDisplayString(data.failureReason), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]))
            : _createCommentVNode("", true),
          (
            (!_ctx.result.AssignedRoles || _ctx.result.AssignedRoles.length === 0) &&
            (!_ctx.result.Errors || _ctx.result.Errors.length === 0)
          )
            ? (_openBlock(), _createBlock("div", _hoisted_39, [
                _createVNode("div", _hoisted_40, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fas', 'info-circle'],
                    class: "me-2 text-info fa-2x mb-3"
                  }),
                  _hoisted_41
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["onOnHiding"]))
}